import {createFeatureSelector, createSelector} from "@ngrx/store";
import {DbStoreState} from "../reducers";
import {IEcommerceCustomersEntityState} from "../reducers/ecommerce-customers.reducer";

const getDbStoreState = createFeatureSelector<DbStoreState>('dbStore');

export const getEcommerceCustomersState = (websiteId: number) =>
  createSelector(getDbStoreState, (dbStoreState: DbStoreState) => dbStoreState.ecommerceCustomers.entities[websiteId]);

export const getCustomers = (websiteId: number) => createSelector(getEcommerceCustomersState(websiteId),
  (state: IEcommerceCustomersEntityState) => {
    return state;
  }
);

export const getCustomer = (websiteId: number) => createSelector(getEcommerceCustomersState(websiteId),
  (state: IEcommerceCustomersEntityState) => {
    if (state && state.customer) {
      if (!state.customer.ordersData.orders) {
        state.customer.ordersData.orders = [];
        state.customer.ordersData.priceList = {};
      }
      return state.customer;
    }
    return null;
  }
);

export const getCustomersLoading = (websiteId: number) => createSelector(getEcommerceCustomersState(websiteId),
  (state: IEcommerceCustomersEntityState) => state && state.loading
);

export const getCustomerFailed = (websiteId: number) => createSelector(getEcommerceCustomersState(websiteId),
  (state: IEcommerceCustomersEntityState) => state && state.failed
);
